import { render } from "./jbedit.vue?vue&type=template&id=771ded4e&scoped=true"
import script from "./jbedit.vue?vue&type=script&lang=js"
export * from "./jbedit.vue?vue&type=script&lang=js"

import "./jbedit.vue?vue&type=style&index=0&id=771ded4e&lang=scss&scoped=true"
import "./jbedit.vue?vue&type=style&index=1&id=771ded4e&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771ded4e"]])

export default __exports__